import React from 'react'
import type { FeedItem } from '../../Api'
import { ArticleCard } from './Articles'
import { VideoCard } from './Videos'

type FeedCardProps = {
  feedItem: FeedItem
  theme?: 'light' | 'dark'
  section?: string
  size?: 'home_featured' | 'featured' | 'normal' | 'small'
}

export const FeedCard: React.FC<React.PropsWithChildren<FeedCardProps>> = ({
  feedItem,
  section,
  theme = 'light',
  size,
}) => {
  return (
    <>
      {feedItem.type === 'article' ? (
        <ArticleCard size={size} article={feedItem} section={section} theme={theme} />
      ) : (
        <VideoCard size={size} video={feedItem} section={section} theme={theme} />
      )}
    </>
  )
}
